<icc-list
    [searchable]="true"
    [items]="handles"
    [itemTemplate]="itemHandle"
    itemWidth="wide"
    itemImgHeight="medium"
    [selected]="selectedHandleId"
    vertical="true"
    (select)="selectHandle($event)"></icc-list>

<ng-template #itemHandle let-item="iccListItem">
    <div class="item-imgTitleDescription">
        <img
            class="item-imgTitleDescription-img"
            [src]="item.imageUrl"
            [alt]="item.title"
            defaultImg
        />
        <p class="item-imgTitleDescription-title">{{ item.title }}</p>
        <p class="item-imgTitleDescription-description" [innerHTML]="item.description"></p>
        <p class="item-imgTitleDescription-colors">
            <span
                *ngFor="let color of item.colors"
                [ngStyle]="{
                    'background-color': '#' + color.color,
                    'background-image': 'url(/files/windowhandlescolor/' + color.colorImg + ')'
                }"
                [title]="color.name"
                [class.selected]="color.id === item.selectedColor"
            >
            </span>
        </p>
    </div>
</ng-template>
